<template>
  <div class="intellectual-property-query">
    <!-- 筛选和操作区域 -->
    <div class="filter-section">
      <div class="filter-container">
        <!-- 证书类型筛选 -->
        <div class="tabs-container">
          <el-tabs
            v-model="activeType"
            @tab-change="handleTypeChange"
          >
            <el-tab-pane
              v-for="tab in visibleCertificateTabs"
              :key="tab.key"
              :name="tab.key"
            >
              <template #label>
                <span>{{ tab.label }}</span>
                <span
                  v-if="tab.hasData"
                  class="type-count"
                >
                  {{ tab.total }}件
                </span>
              </template>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!-- 操作按钮 -->
        <div class="action-buttons">
          <!-- <el-button @click="handleExport">
            导出
          </el-button> -->
          <!--
          <el-button
            type="primary"
            @click="handleImport"
          >
            导入知产管理
          </el-button>
           -->
        </div>
      </div>
    </div>

    <!-- 查询结果表格区域 -->
    <div class="table-section">
      <div class="table-container">
        <el-table
          v-loading="loading"
          class="ip-result-table"
          :data="tableData"
          stripe
          style="width: 100%"
        >
          <template #empty>
            <div
              v-if="needsPersonalRealName"
              class="table-empty-realname"
            >
              <p class="table-empty-realname__text">
                根据您当前查询内容，需要完成身份认证后进行查询
              </p>
              <span class="table-empty-realname__action">
                去完成【<span
                  class="table-empty-realname__link"
                  style="text-decoration: underline;"
                  @click="handleGoAuth"
                >个人身份认证</span>】</span>
            </div>
            <span
              v-else
              class="table-empty-default"
            >{{ emptyText }}</span>
          </template>

          <!-- 作品著作权列 -->
          <template v-if="activeType === CERTIFICATE_TYPE.WORK_COPYRIGHT">
            <el-table-column
              prop="regNo"
              label="登记号"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="workName"
              label="作品名称"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="workType"
              label="作品类别"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="author"
              label="著作权人/权利人"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="regDate"
              label="登记日期"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="finishDate"
              label="创作完成日期"
              align="center"
              show-overflow-tooltip
            />
          </template>

          <!-- 软件著作权列 -->
          <template v-else-if="activeType === CERTIFICATE_TYPE.SOFTWARE_COPYRIGHT">
            <el-table-column
              prop="regNo"
              label="登记号"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="softwareName"
              label="软件名称"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="version"
              label="版本号"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="copyrightOwner"
              label="著作权人/权利人"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="regDate"
              label="登记日期"
              align="center"
            />
          </template>

          <!-- 商标信息列 -->
          <template v-else-if="activeType === CERTIFICATE_TYPE.TRADEMARK">
            <el-table-column
              prop="regNo"
              label="注册号"
              align="center"
              width="120"
              show-overflow-tooltip
            />
            <el-table-column
              label="商标"
              align="center"
              width="120"
            >
              <template #default="{ row }">
                <el-image
                  v-if="row.tmPic"
                  :src="row.tmPic"
                  class="trademark-image"
                  fit="contain"
                  :preview-src-list="[row.tmPic]"
                  :initial-index="0"
                  preview-teleported
                />
                <span
                  v-else
                  class="no-image"
                >-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="tmName"
              label="商标名称"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              label="商标分类"
              align="center"
              width="120"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                {{ row.tmCode }}
              </template>
            </el-table-column>
            <el-table-column
              label="商品和服务分类"
              align="center"
              width="128"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                {{ row.tmCodeName }}
              </template>
            </el-table-column>

            <el-table-column
              prop="applicant"
              label="申请人"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="applicantDate"
              label="申请日期"
              align="center"
              width="100"
              show-overflow-tooltip
            />
            <!-- <el-table-column
              prop="status"
              label="状态"
              align="center"
              width="120"
              show-overflow-tooltip
            /> -->
          </template>
          <!-- 专利信息列 -->
          <template v-else-if="activeType === CERTIFICATE_TYPE.PATENT">
            <el-table-column
              prop="patentNo"
              label="专利号"
              align="center"
              width="180"
              show-overflow-tooltip
            />
            <el-table-column
              prop="patentName"
              label="专利名称"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="patentType"
              label="专利类型"
              align="center"
              width="100"
              show-overflow-tooltip
            />
            <el-table-column
              prop="inventor"
              label="发明人"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="applicant"
              label="申请人"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="applicationDate"
              label="申请日期"
              align="center"
              width="130"
              show-overflow-tooltip
            />
            <el-table-column
              prop="grantDate"
              label="授权公告日"
              align="center"
              width="130"
              show-overflow-tooltip
            />
            
            <!-- <el-table-column
              prop="status"
              label="状态"
              align="center"
              width="120"
              show-overflow-tooltip
            /> -->
          </template>
        </el-table>

        <!-- 分页 -->
        <div
          v-if="pagination.total > 0"
          class="pagination-container"
        >
          <el-pagination
            v-model:current-page="pagination.currentPage"
            v-model:page-size="pagination.pageSize"
            :page-sizes="[20]"
            :total="pagination.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>

    <!-- 身份认证提示 -->
    <div
      v-if="showAuthPrompt"
      class="auth-prompt"
    >
      <div class="prompt-content">
        <p class="prompt-text">
          根据您当前查询内容,需要完成身份认证后进行查询
        </p>
        <span
          class="auth-link"
          @click="handleGoAuth"
        >
          去完成<span class="link-highlight">【个人身份认证】</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import { isLoggedIn, hasPersonalType, isIdentityVerified } from '@/utils/auth'
import { queryIntellectualProperty, exportIntellectualProperty, importIntellectualPropertyToManagement } from '@/api/intellectualProperty'
import { CERTIFICATE_TYPE, CERTIFICATE_TYPE_DISPLAY } from '@/enums/CertificateTypeEnum'
import { showEnhancedConfirmDialog } from '@/utils/messageUtils'
import { withLoading } from '@/utils/loadingUtils'
import { getCurrentDateTimeDashString } from '@/utils/dateUtils'

export default {
  name: 'IntellectualPropertyQuery',
  props: {
    // 查询参数（从父组件传入）
    searchParams: {
      type: Object,
      default: () => ({
        keyword: '',
        filters: {},
        activeType: null // 默认选中的证书类型
      })
    },
    /** 为 false 时仅同步 keyword/filters 与 Tab，不自动请求列表（如首页从内链打开内联查询区） */
    autoRunQuery: {
      type: Boolean,
      default: true
    }
  },
  emits: ['show-login-dialog'],
  data() {
    return {
      CERTIFICATE_TYPE,
      /** Tab 展示顺序（不依赖对象键枚举顺序） */
      certificateTabOrder: [
        CERTIFICATE_TYPE.WORK_COPYRIGHT,
        CERTIFICATE_TYPE.SOFTWARE_COPYRIGHT,
        CERTIFICATE_TYPE.TRADEMARK,
        CERTIFICATE_TYPE.PATENT
      ],
      exportXlsxMime:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      activeType: CERTIFICATE_TYPE.WORK_COPYRIGHT,
      tableData: [],
      // 个人账号未完成实名：在表格空状态内提示
      needsPersonalRealName: false,
      // 是否显示身份认证提示
      showAuthPrompt: false,
      // 空状态文本
      emptyText: '暂无数据',
      // 当前查询关键词
      currentKeyword: '',
      // 当前筛选条件
      currentFilters: {},
      // 加载状态
      loading: false,
      // 分页信息（与当前 Tab 同步，用于 el-pagination 绑定）
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      /** 各证书类型独立分页：{ '1'|'2'|... : { currentPage, pageSize } } */
      paginationByType: {},
      // 存储各类型数据的映射
      allDataMap: {}
    }
  },
  computed: {
    /** 本次查询勾选的知产类型（优先父组件传入的 searchParams.filters，否则用当前查询条件）；无勾选时不限制，Tab 展示全部 */
    selectedFilterTypeKeys() {
      const fromProps = this.selectedTruthyFilterKeys(this.searchParams?.filters || {})
      if (fromProps.length) return fromProps
      return this.selectedTruthyFilterKeys(this.currentFilters || {})
    },
    /** 有勾选类型时只展示对应 Tab，与首页/查询带过来的筛选一致 */
    visibleCertificateTabs() {
      const map = CERTIFICATE_TYPE_DISPLAY
      const m = this.allDataMap
      const selected = this.selectedFilterTypeKeys
      const keysToShow =
        selected.length > 0
          ? this.certificateTabOrder.filter((key) => selected.includes(String(key)))
          : this.certificateTabOrder
      return keysToShow.map((key) => {
        const hasData = Object.prototype.hasOwnProperty.call(m, key)
        const total = hasData ? (m[key]?.total ?? 0) : null
        return {
          key,
          label: map[key],
          hasData,
          total
        }
      })
    }
  },
  watch: {
    // 监听查询参数变化，自动执行查询（immediate：父组件首屏同步传入 searchParams 时也要查一次）
    searchParams: {
      handler(newVal) {
        if (!newVal) return
        this.setActiveTypeFromFilters(newVal.filters)
        if (!this.autoRunQuery) {
          this.currentKeyword =
            newVal.keyword != null ? String(newVal.keyword).trim() : ''
          this.currentFilters = { ...(newVal.filters || {}) }
          return
        }
        const hasKeyword = !!(newVal.keyword && String(newVal.keyword).trim())
        const hasTruthyFilter =
          this.selectedTruthyFilterKeys(newVal.filters || {}).length > 0
        if (hasKeyword || hasTruthyFilter) {
          this.handleQuery(newVal)
        }
      },
      deep: true,
      immediate: true
    },
    visibleCertificateTabs: {
      handler(tabs) {
        if (!tabs.length) return
        const at = String(this.activeType)
        if (!tabs.some((t) => String(t.key) === at)) {
          this.activeType = String(tabs[0].key)
        }
      },
      immediate: true
    },
    /** el-tabs v-model 可能为数字，与 tab.name（字符串）严格不等会导致列模板 v-if 全不命中 */
    activeType(val) {
      if (val == null) return
      const s = String(val)
      if (s !== val) this.activeType = s
    }
  },
  mounted() {
    if (!isLoggedIn()) this.showAuthPrompt = true
  },
  methods: {
    selectedTruthyFilterKeys(filters) {
      if (!filters || typeof filters !== 'object') return []
      const allowed = new Set(this.certificateTabOrder)
      return Object.keys(filters)
        .filter((k) => k !== 'all' && filters[k] === true)
        .map((k) => String(k))
        .filter((k) => allowed.has(k))
    },
    unwrapListResponse(response) {
      if (response?.code === 200) return response.data || response
      return response || {}
    },
    triggerBlobDownload(blob, fileName) {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    setActiveTypeFromFilters(filters = {}) {
      const selected = this.selectedTruthyFilterKeys(filters)
      if (!selected.length) return
      const first = this.certificateTabOrder.find((key) => selected.includes(key) && CERTIFICATE_TYPE_DISPLAY[key])
      if (first) this.activeType = String(first)
    },
    ensurePaginationState(type) {
      const key = String(type)
      if (!this.paginationByType[key]) {
        this.paginationByType[key] = { currentPage: 1, pageSize: 20 }
      }
      return this.paginationByType[key]
    },
    /** 将 el-pagination 的 pagination 与当前 activeType 的分页状态、缓存 total 对齐 */
    syncPaginationFromActiveType() {
      const t = String(this.activeType)
      const p = this.ensurePaginationState(t)
      const cached = this.allDataMap[t]
      this.pagination.currentPage = p.currentPage
      this.pagination.pageSize = p.pageSize
      this.pagination.total = cached ? cached.total || 0 : 0
    },
    /** 仅切换展示：有缓存则展示缓存，否则空表；不发起接口请求 */
    handleTypeChange() {
      const cached = this.allDataMap[String(this.activeType)]
      this.syncPaginationFromActiveType()
      if (cached) {
        this.tableData = cached.rows || []
        this.emptyText = this.tableData.length ? '' : '暂无查询结果'
      } else {
        this.tableData = []
        this.needsPersonalRealName = false
        this.emptyText = '暂无数据'
      }
    },
    // 处理查询（从父组件调用或内部调用）
    handleQuery(params = null) {
      // 如果没有传入参数，使用当前保存的查询条件
      const queryParams = params || {
        keyword: this.currentKeyword,
        filters: this.currentFilters
      }

      // 保存当前查询条件
      this.currentKeyword = queryParams.keyword || ''
      this.currentFilters = queryParams.filters || {}

      // 根据筛选条件自动设置证书类型（如果有筛选条件）
      if (queryParams.filters) {
        this.setActiveTypeFromFilters(queryParams.filters)
      }

      this.allDataMap = {}

      // 检查是否有查询条件
      if (!this.currentKeyword?.trim() && !this.hasActiveFilters()) {
        ElMessage.warning('请输入查询关键词或选择筛选条件')
        this.tableData = []
        this.pagination.total = 0
        this.needsPersonalRealName = false
        return
      }

      // 默认一下子查询所有选择的标签的数据
      const typesToFetch = this.selectedTruthyFilterKeys(this.currentFilters).join(',') || this.activeType
      typesToFetch
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
        .forEach((t) => {
          const p = this.ensurePaginationState(t)
          p.currentPage = 1
        })

      // 执行查询
      this.loadTableData(typesToFetch)
    },
    // 检查是否有激活的筛选条件
    hasActiveFilters() {
      return this.selectedTruthyFilterKeys(this.currentFilters).length > 0
    },
    // 加载表格数据
    async loadTableData(fetchTypes) {
      // 检查是否有查询条件
      if (!this.currentKeyword?.trim() && !this.hasActiveFilters()) {
        this.tableData = []
        this.emptyText = '暂无数据'
        this.pagination.total = 0
        this.needsPersonalRealName = false
        return
      }

      // 检查登录状态
      if (!isLoggedIn()) {
        this.showAuthPrompt = true
        this.needsPersonalRealName = false
        this.tableData = []
        this.emptyText = '请先登录后查询'
        return
      }

      this.loading = true
      this.emptyText = '加载中...'

      try {
        if (hasPersonalType()) {
          const verified = isIdentityVerified()
          console.log('verified', verified)
          if (!verified) {
            this.needsPersonalRealName = true
            this.showAuthPrompt = false
            this.tableData = []
            this.pagination.total = 0
            return
          }
          this.needsPersonalRealName = false
        }

        const typesList = String(fetchTypes != null ? fetchTypes : this.activeType)
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
        const isMulti = typesList.length > 1

        let pageNum = 1
        let pageSize = 20
        if (isMulti) {
          const first = typesList[0]
          pageSize = this.ensurePaginationState(first).pageSize
          typesList.forEach((t) => {
            const p = this.ensurePaginationState(t)
            p.currentPage = 1
            p.pageSize = pageSize
          })
          pageNum = 1
        } else {
          const t = typesList[0] || String(this.activeType)
          const p = this.ensurePaginationState(t)
          pageNum = p.currentPage
          pageSize = p.pageSize
        }

        const typesToFetch = typesList.join(',')
        const response = await queryIntellectualProperty(
          typesToFetch,
          this.currentKeyword,
          pageNum,
          pageSize
        )

        const responseData = this.unwrapListResponse(response)

        const requestedTypes = typesList
        const isMapResponse =
          responseData &&
          typeof responseData === 'object' &&
          requestedTypes.some((type) => responseData[type] !== undefined)

        if (isMapResponse) {
          const next = { ...this.allDataMap }
          typesList.forEach((t) => {
            const block = responseData[t]
            next[t] = {
              rows: block?.rows || [],
              total: block?.total ?? 0
            }
          })
          this.allDataMap = next
          const at = String(this.activeType)
          const current = this.allDataMap[at] || { rows: [], total: 0 }
          this.tableData = Array.isArray(current.rows) ? [...current.rows] : []
        } else {
          const t = typesList[0] || String(this.activeType)
          const rows = responseData.rows || []
          this.tableData = Array.isArray(rows) ? [...rows] : []
          const total = responseData.total || 0
          this.allDataMap = {
            ...this.allDataMap,
            [t]: { rows, total }
          }
        }

        this.syncPaginationFromActiveType()
        this.activeType = String(this.activeType)

        if (this.tableData.length === 0) {
          this.emptyText = '暂无查询结果'
        }
      } catch (error) {
        console.error('查询失败:', error)
        this.tableData = []
        this.emptyText = '查询失败，请重试'
      } finally {
        this.loading = false
        this.showAuthPrompt = !isLoggedIn()
      }
    },
    // 分页大小改变（仅当前 Tab）
    handleSizeChange(size) {
      const t = String(this.activeType)
      const p = this.ensurePaginationState(t)
      p.pageSize = size
      p.currentPage = 1
      this.pagination.pageSize = size
      this.pagination.currentPage = 1
      this.loadTableData(t)
    },
    // 当前页改变（仅当前 Tab）
    handleCurrentChange(page) {
      const t = String(this.activeType)
      const p = this.ensurePaginationState(t)
      p.currentPage = page
      this.pagination.currentPage = page
      this.loadTableData(t)
    },
    // 处理导出
    async handleExport() {
      if (!isLoggedIn()) {
        this.$emit('show-login-dialog')
        return
      }

      // 检查是否有查询条件
      if (!this.currentKeyword?.trim()) {
        ElMessage.warning('请先输入查询关键词')
        return
      }

      const typeName = CERTIFICATE_TYPE_DISPLAY[this.activeType] || 'null'
      const total = this.pagination.total || 0

      if (total === 0) {
        ElMessage.warning('当前暂无数据可导出')
        return
      }

      try {
        const confirmed = await showEnhancedConfirmDialog(`确定要导出当前【${typeName}】的 ${total} 条查询结果吗？`, '导出确认')
        if (!confirmed) return
        
        await withLoading(async () => {
          // 使用统一导出接口
          const p = this.ensurePaginationState(this.activeType)
          const response = await exportIntellectualProperty(
            this.activeType,
            this.currentKeyword,
            p.currentPage,
            p.pageSize
          )

          const blob = new Blob([response], { type: this.exportXlsxMime })
          this.triggerBlobDownload(blob, `${typeName}_${getCurrentDateTimeDashString()}.xlsx`)
          ElMessage.success('导出成功')
        }, { text: '导出中，请稍候...', target: '.table-section' })
      } catch (error) {
        console.error('导出失败:', error)
      }
    },
    // 处理导入知产管理
    async handleImport() {
      if (!isLoggedIn()) {
        this.$emit('show-login-dialog')
        return
      }

      const typeName = CERTIFICATE_TYPE_DISPLAY[this.activeType] || '知识产权信息'
      const total = this.pagination.total || 0

      if (total === 0) {
        ElMessage.warning('当前暂无数据可导入')
        return
      }
      
      try {
        const importConfirmHtml =
          `确定要将当前【${typeName}】的 ${total} 条信息导入到知产管理吗？` +
          '<br/><span style="color: #f56c6c;">(该操作会将查询结果同步到知产管理中。若知产管理中的数据未在查询结果中，则会被删除！)</span>'
        const confirmed = await showEnhancedConfirmDialog(
          importConfirmHtml,
          '导入确认',
          '确定',
          '取消',
          { dangerouslyUseHTMLString: true }
        )
        if (!confirmed) return
        
        await withLoading(async () => {
          const res = await importIntellectualPropertyToManagement(this.activeType, this.currentKeyword)
          if (res && res.code === 200) {
            ElMessage.success(res.msg || '导入请求已提交')
          }
        }, { text: '导入中，请稍候...', target: '.table-section' })
      } catch (error) {
        console.error('导入失败:', error)
      }
    },
    // 跳转到身份认证页面
    handleGoAuth() {
      this.$router.push({ path: '/user-center/account/personal-auth' })
    }
  }
}
</script>

<style lang="scss" scoped>
.intellectual-property-query {
  width: 100%;
  min-width: 0;
  min-height: calc(100vh - 200px);
  padding: clamp(24px, 4vw, 40px) 0 clamp(40px, 5vw, 60px);
  background-color: #fff;
  overflow-x: hidden;
}

/* 筛选与操作 */
.filter-section {
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  padding-left: clamp(16px, 3vw, 30px);
  padding-right: clamp(16px, 3vw, 30px);
  box-sizing: border-box;

  .filter-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    min-width: 0;
    padding-bottom: 2px;

    &::after {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 0;
      height: 2px;
      background-color: #e4e7ed;
      pointer-events: none;
    }

    .tabs-container {
      position: relative;
      z-index: 1;
      flex: 1 1 0;
      min-width: 0;
      max-width: 100%;
      padding: 0;
      border-radius: 4px;
      background-color: #fff;

      :deep(.el-tabs) {
        min-width: 0;
      }

      :deep(.el-tabs__header) {
        margin: 0;
      }

      :deep(.el-tabs__nav-wrap) {
        max-width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      :deep(.el-tabs__nav-scroll) {
        overflow: visible;
      }

      :deep(.el-tabs__nav-wrap::after) {
        display: none;
      }

      :deep(.el-tabs__item) {
        height: 50px;
        box-sizing: border-box;
        min-width: 128px;
        font-size: 14px;
        font-weight: 600;
        line-height: 50px;
        justify-content: center;

        &:last-child {
          margin-right: 0;
        }

        &.is-active {
          font-weight: 600;
          color: #0d62f3;
        }

        &:hover {
          color: #0d62f3;
        }

        .type-count {
          margin-left: 6px;
          font-size: 13px;
          font-weight: 500;
          color: #909399;
        }

        &.is-active .type-count {
          color: #0d62f3;
        }
      }

      :deep(.el-tabs__active-bar) {
        z-index: 2;
        height: 3px;
        background-color: #0d62f3;
        border-radius: 2px;
      }
    }

    .action-buttons {
      position: relative;
      z-index: 1;
      display: flex;
      flex-shrink: 0;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;

      :deep(.el-button + .el-button) {
        margin-left: 0;
      }
    }
  }
}

/* 表格与分页 */
.table-section {
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  padding-left: clamp(16px, 3vw, 30px);
  padding-right: clamp(16px, 3vw, 30px);
  box-sizing: border-box;

  .table-container {
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #fff;

    :deep(.ip-result-table.el-table) {
      min-width: 860px;

      .el-table__header th {
        font-weight: 600;
        color: #606266;
        background-color: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;
      }

      .el-table__body tr:hover {
        background-color: #f5f7fa;
      }

      .el-table__body td {
        border-bottom: 1px solid #f0f0f0;
      }

      .el-table__empty-block {
        min-height: 318px;
        padding: 80px 0;
      }
    }

    .trademark-image {
      width: 60px;
      height: 60px;
      cursor: pointer;
      border: 1px solid #e4e7ed;
      border-radius: 4px;

      :deep(.el-image__inner) {
        object-fit: contain;
      }
    }

    .no-image {
      color: #909399;
    }

    .table-empty-realname {
      line-height: 1.7;
      text-align: center;

      &__text {
        font-weight: 500;
        margin: 0 0 12px;
        font-size: 14px;
        color: #303133;
      }

      &__action {
        font-size: 14px;
        color: #303133;
        cursor: pointer;
      }

      &__link {
        font-weight: 500;
        color: #0d62f3;
        text-decoration: underline;
      }
    }

    .table-empty-default {
      font-size: 14px;
      color: #909399;
    }

    .pagination-container {
      display: flex;
      justify-content: flex-end;
      min-width: 860px;
      padding: 20px;
      border-top: 1px solid #e4e7ed;

      :deep(.el-pagination) {
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: 8px 0;
      }
    }
  }
}

/* 未登录提示 */
.auth-prompt {
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding-left: clamp(16px, 3vw, 30px);
  padding-right: clamp(16px, 3vw, 30px);
  box-sizing: border-box;

  .prompt-content {
    padding: 40px 20px;
    text-align: center;
    background-color: #f5f7fa;
    border-radius: 4px;

    .prompt-text {
      margin: 0 0 16px;
      font-size: 14px;
      line-height: 1.6;
      color: #606266;
    }

    .auth-link {
      font-size: 14px;
      color: #606266;
      cursor: pointer;

      .link-highlight {
        font-weight: 500;
        color: #409eff;

        &:hover {
          text-decoration: underline;
        }
      }

      &:hover .link-highlight {
        text-decoration: underline;
      }
    }
  }
}

/* ≤1024px */
@media (max-width: 1024px) {
  .filter-section {
    margin-bottom: 24px;

    .filter-container {
      flex-direction: column;
      align-items: flex-start;

      .tabs-container {
        width: 100%;
        margin-bottom: 16px;
      }

      .action-buttons {
        width: 100%;
        justify-content: flex-end;
      }
    }
  }

  .table-section {
    margin-bottom: 24px;
  }
}

/* ≤768px */
@media (max-width: 768px) {
  .intellectual-property-query {
    padding: 24px 0 40px;
  }

  .filter-section {
    margin-bottom: 20px;

    .filter-container .tabs-container {
      width: 100%;
      margin-bottom: 16px;
      padding: 0;

      :deep(.el-tabs__item) {
        min-width: 104px;
        padding: 0 12px;
        font-size: 13px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .filter-container .action-buttons {
      flex-direction: column;
      width: 100%;

      :deep(.el-button) {
        width: 100%;
        margin-left: 0;
      }
    }
  }

  .table-section {
    margin-bottom: 20px;

    .table-container :deep(.ip-result-table.el-table) {
      font-size: 12px;

      .el-table__header th,
      .el-table__body td {
        padding: 10px 5px;
        font-size: 12px;
      }
    }
  }

  .auth-prompt .prompt-content {
    padding: 30px 15px;

    .prompt-text,
    .auth-link {
      font-size: 13px;
    }
  }
}

@media (max-width: 420px) {
  .filter-section,
  .table-section,
  .auth-prompt {
    padding-left: 12px;
    padding-right: 12px;
  }

  .filter-section {
    .filter-container {
      gap: 12px;
    }
  }

  .table-section {
    .table-container {
      :deep(.ip-result-table.el-table) {
        min-width: 760px;
      }

      .pagination-container {
        min-width: 760px;
        padding: 14px 12px;
      }
    }
  }
}
</style>
